// import { Message } from "element-ui";
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d}'
    const date = new Date(time)
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
        return value.toString().padStart(2, '0')
    })
    return time_str
}
/**
 * 防抖函数
 * @param {Function} 
 * @param {number} time
 */
let timeout = null //注意：timeout不能放在函数内部
export function debounce(fn, wait) {
    // if (timeout) {
    //     return (
    //         function (val) {
    //             if (val) {
    //                 Message({
    //                     message: val,
    //                     type: "error",
    //                     duration: 2 * 1000,
    //                 })
    //             }
    //         });
    // }
    return (function () {
        // !timeout && fn()//立即执行
        if (timeout) {
            clearTimeout(timeout)
        }
        timeout = setTimeout(() => {
            fn()
            // timeout = null//过wait时间后才允许执行
        }, wait)
    })
}
/**
 * 防抖函数
 * @param {Function} 
 * @param {number} time
 */
let Routetimeout = null //注意：timeout不能放在函数内部
export function Routedebounce(fn, wait) {
    // if (timeout) {
    //     return (
    //         function (val) {
    //             if (val) {
    //                 Message({
    //                     message: val,
    //                     type: "error",
    //                     duration: 2 * 1000,
    //                 })
    //             }
    //         });
    // }
    return (function () {
        // !timeout && fn()//立即执行
        if (Routetimeout) {
            clearTimeout(Routetimeout)
        }
        Routetimeout = setTimeout(() => {
            fn()
            // timeout = null//过wait时间后才允许执行
        }, wait)
    })
}


/**
 * 格式化数字金额用逗号隔开保留两位小数函数
 * @param {Function} 
 * @param {number} s
 */

export function dataFormat(s) {
    // n = n > 0 && n <= 20 ? n : 2;
    var n = 2;
    s = parseFloat((s + "").replace(/[^\d/.-]/g, ""))+ "";
    // s = parseFloat((s + "").replace(/[^\d/.-]/g, "")).toFixed(n) + "";
    // console.log(s)
    var l = s.split(".")[0].split("").reverse(), r = s.split(".")[1];
    var t = "";
    if (l[l.length - 1] === '-') {
        l.pop()
        for (let i = 0; i < l.length; i++) {
            t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
        }
        t += '-'
    } else {
        for (let i = 0; i < l.length; i++) {
            t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
        }
    }
    if(!r){
        r='00'
    }
    return t.split("").reverse().join("") + "." + r;
}
/**
     * 减法运算，避免数据相减小数点后产生多位数和计算精度损失。
     *
     * @param num1被减数  |  num2减数
     */
export function numSub(num1, num2) {
    var baseNum, baseNum1, baseNum2;
    var precision; // 精度
    try {
        baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
        baseNum1 = 0;
    }
    try {
        baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
        baseNum2 = 0;
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    precision = baseNum1 >= baseNum2 ? baseNum1 : baseNum2;
    return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
}
/**
     * 加法运算，避免数据相减小数点后产生多位数和计算精度损失。
     *
     * @param num1被减数  |  num2减数
     */
export function numAdd(num1, num2) {
    var baseNum, baseNum1, baseNum2;
    var precision; // 精度
    try {
        baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
        baseNum1 = 0;
    }
    try {
        baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
        baseNum2 = 0;
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    precision = baseNum1 >= baseNum2 ? baseNum1 : baseNum2;
    return ((num1 * baseNum + num2 * baseNum) / baseNum).toFixed(precision);
}
/**
 * 乘法运算，避免数据相减小数点后产生多位数和计算精度损失。
 *
 * @param num1被乘数  |  num2乘数
 */
export function numMul(num1, num2) {
    var baseNum, baseNum1, baseNum2;
    var precision; // 精度
    try {
        baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
        baseNum1 = 0;
    }
    try {
        baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
        baseNum2 = 0;
    }
    baseNum = Math.pow(10, baseNum1 + baseNum2);
    precision = baseNum * baseNum;
    return Number(((num1 * num2 * precision) / precision).toFixed(
        baseNum1 + baseNum2
    ));
}
//文字溢出时添加标签
export function titeEnter(e) {
  const target = e.target;
  const { clientWidth, scrollWidth, title } = target;
  if (!title && scrollWidth > clientWidth) target.title = target.innerText;
}
//时间转换
export function dateFormat(fmt, date) {
    let ret = "";
    date = new Date(date);
    const opt = {
      "Y+": date.getFullYear().toString(), // 年
      "m+": (date.getMonth() + 1).toString(), // 月
      "d+": date.getDate().toString(), // 日
      "H+": date.getHours().toString(), // 时
      "M+": date.getMinutes().toString(), // 分
      "S+": date.getSeconds().toString(), // 秒
    };
    for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
        fmt = fmt.replace(
          ret[1],
          ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
        );
      }
    }
    return fmt;
  }